import { render, staticRenderFns } from "./ProfitForcast.vue?vue&type=template&id=31050cd2&scoped=true&"
import script from "./ProfitForcast.vue?vue&type=script&lang=ts&"
export * from "./ProfitForcast.vue?vue&type=script&lang=ts&"
import style0 from "./ProfitForcast.vue?vue&type=style&index=0&id=31050cd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31050cd2",
  null
  
)

export default component.exports